// Canonical unit-of-measure helpers (mirrors the backend app/utils/units.py).
//
// A "pieces" line is priced PER PIECE: its amount is price × piece count, and at
// loading/unloading the delivered/received PIECE COUNT is what the operator
// captures (the weight, when entered, is only for weighbridge/costing).
//
// Several screens had re-implemented this check inline and inconsistently (some
// omitted 'pc'/'nos'/'no'); import this single helper instead.
export const PIECE_UNITS = ['pcs', 'pc', 'piece', 'pieces', 'nos', 'no'];

export const isPieceUnit = (u) => PIECE_UNITS.includes(String(u || '').trim().toLowerCase());

// A line should be treated as "loaded by pieces" when either the operator flagged
// it (load_by_pieces) or its unit of measure is pieces.
export const isPieceLoad = (item) =>
  !!(item && (item.load_by_pieces || isPieceUnit(item.unit || item.units)));

// The ONLY three units of measure, matching the backend's canonical set
// (app/utils/units.py: KG / M / PCS). Order, purchase-order and inquiry lines
// all use these, and the models normalize any accepted spelling to them on
// assignment (@validates), so the stored value is always one of these three.
export const CANONICAL_UNITS = ['kg', 'm', 'pcs'];

const _UNIT_ALIASES = {
  kg: 'kg', kgs: 'kg', kilogram: 'kg', kilograms: 'kg',
  m: 'm', mtr: 'm', mtrs: 'm', meter: 'm', meters: 'm', metre: 'm', metres: 'm',
  pcs: 'pcs', pc: 'pcs', piece: 'pcs', pieces: 'pcs', nos: 'pcs', no: 'pcs',
};

// Map any accepted spelling to the canonical form. Mirrors normalize_unit() in
// app/utils/units.py, including its tolerance: an unrecognised value comes back
// lowercased and trimmed rather than dropped. Applied when a line is loaded, so
// a row written before the vocabulary was unified still selects the right
// <option> instead of falling through to the first one and being silently
// rewritten on save.
export const normalizeUnit = (u) => {
  const cleaned = String(u ?? '').trim().toLowerCase();
  if (!cleaned) return cleaned;
  return _UNIT_ALIASES[cleaned] || cleaned;
};
